import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'white' | 'offwhite' | 'navy';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    offwhite: 'bg-offwhite',
    navy: 'bg-navy text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${bgColors[bg]} ${className}`} data-id="element-479">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-480">
        {children}
      </motion.div>
    </section>;
}